import React, { useMemo } from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { TooltipContent } from '../types';
import { InfoIcon } from 'lucide-react';


interface BenefitTooltipProps {
    tooltip?: TooltipContent;
  }

export default function BenefitTooltip({ tooltip }: BenefitTooltipProps) {
    if (!tooltip || !tooltip.data?.length) {
        return null;
    }
    const tooltipContent = useMemo(() => (
        <Box sx={{ 
            color: 'white', 
            lineHeight: 1.5, 
            padding: 0.5, 
            paddingBottom: 1,
            maxWidth: '280px',
            minWidth: '200px'
        }}>
            {tooltip.heading && (
                <Typography
                    variant="subtitle1"
                    sx={{ 
                        fontWeight: 500, 
                        mb: 1, 
                        fontSize: '14px',
                        wordWrap: 'break-word',
                        whiteSpace: 'normal'
                    }}
                >
                    {tooltip.heading}
                </Typography>
            )}
            <Stack spacing={1}>
                {tooltip.data.map((item, idx) => (
                    <Box
                        key={idx}
                        display="flex"
                        justifyContent="space-between"
                        sx={{ 
                            gap: 2, 
                            minWidth: '200px',
                            flexWrap: 'wrap',
                            alignItems: 'flex-start'
                        }}
                    >
                        <Typography 
                            variant="body2" 
                            fontSize={'12px'}
                            sx={{ 
                                flex: 1,
                                wordWrap: 'break-word',
                                whiteSpace: 'normal'
                            }}
                        >
                            {item.time}
                        </Typography>
                        <Typography 
                            variant="body2" 
                            fontSize={'12px'}  
                            sx={{ 
                                fontWeight: 500,
                                textAlign: 'right',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {item.charge}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </Box>
    ), [tooltip]);

    return (
        <Tooltip
            placement="top"
            title={tooltipContent}
        >
            <InfoIcon
                style={{
                    color: '#999',
                    height: 12,
                    width: 12,
                    minHeight: 12,
                    minWidth: 12,
                    flexShrink: 0,
                    display: 'inline-block',
                    cursor: 'pointer',
                    margin: "0px 5px",
                    verticalAlign: 'middle'
                }}
            />
        </Tooltip>
    );
}